// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const CurPriceSource =
{
    Level1: 0, Trades: 1, Level1MainOnly: 2
};